import type {
  ViewFolderId,
  ViewId,
} from "@redotech/effect-api-shared/ids/definitions";
import type {
  FolderResponse,
  ViewColumnsConfig,
  ViewResponse,
} from "@redotech/effect-api-shared/rpc/view-folder";
import {
  coerceSupportTicketSorts,
  type SupportTicketSort,
} from "@redotech/effect-api-shared/schema/query-options";
import type { FilterGroup } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";

export interface CreateSupportTicketViewInput {
  id: ViewId;
  name: string;
  filterGroup: FilterGroup | null;
  folderId: ViewFolderId | null;
  columns: ViewColumnsConfig | null;
  sort: readonly SupportTicketSort[] | null;
}

export interface UpdateSupportTicketViewInput {
  name: string;
  filterGroup: FilterGroup | null;
  folderId: ViewFolderId | null;
  columns: ViewColumnsConfig | null;
  sort: readonly SupportTicketSort[] | null;
}

export interface CreateSupportTicketFolderInput {
  id: ViewFolderId;
  name: string;
  viewIds: string[];
  isPrivate: boolean;
  defaultViews: string[];
}

export interface UpdateSupportTicketFolderInput {
  name: string;
  viewIds: string[];
  defaultViews: string[];
}

export function toCreateSupportTicketViewInput(
  view: ViewResponse,
): CreateSupportTicketViewInput {
  return {
    id: view.id,
    name: view.name,
    filterGroup: (view.filterGroup as FilterGroup) ?? null,
    folderId: view.folderId ?? null,
    columns: view.columns ?? null,
    sort: coerceSupportTicketSorts(view.sort),
  };
}

export function toUpdateSupportTicketViewInput(
  view: ViewResponse,
): UpdateSupportTicketViewInput {
  return {
    name: view.name,
    filterGroup: (view.filterGroup as FilterGroup) ?? null,
    folderId: view.folderId ?? null,
    columns: view.columns ?? null,
    sort: coerceSupportTicketSorts(view.sort),
  };
}

export function toCreateSupportTicketFolderInput(
  folder: FolderResponse,
): CreateSupportTicketFolderInput {
  return {
    id: folder.id,
    name: folder.name,
    viewIds: [],
    isPrivate: folder.isPrivate,
    defaultViews: [...folder.defaultViews],
  };
}

export function toUpdateSupportTicketFolderInput(
  folder: FolderResponse,
): UpdateSupportTicketFolderInput {
  return {
    name: folder.name,
    viewIds: [],
    defaultViews: [...folder.defaultViews],
  };
}
